/** @format */

export const TrashSmall = ({color}) => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_466_309)">
                <path
                    d="M10.333 2.66667L9.66634 2H6.33301L5.66634 2.66667H3.33301V4H12.6663V2.66667H10.333ZM3.99967 12.6667C3.99967 13.4 4.59967 14 5.33301 14H10.6663C11.3997 14 11.9997 13.4 11.9997 12.6667V4.66667H3.99967V12.6667ZM5.33301 9.33333V6H10.6663V9.33333V12.6667H5.33301V9.33333Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_466_309">
                    <rect width="16" height="16" fill={color} />
                </clipPath>
            </defs>
        </svg>
    );
};
